import { render, staticRenderFns } from "./AuthV2Layout.vue?vue&type=template&id=35d9959e&scoped=true&"
import script from "./AuthV2Layout.vue?vue&type=script&lang=js&"
export * from "./AuthV2Layout.vue?vue&type=script&lang=js&"
import style0 from "./AuthV2Layout.vue?vue&type=style&index=0&id=35d9959e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9959e",
  null
  
)

export default component.exports